import { type BaseParams, links, Request } from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';
import { setError } from '@app/store/actions/error';

export interface CurrencyData {
    usd?: number;
}

export interface CurrencyResponse {
    aptos: CurrencyData;
    ethereum: CurrencyData;
    'matic-network': CurrencyData;
}

const supportedCurrencies: (keyof CurrencyResponse)[] = ['aptos', 'ethereum', 'matic-network'];

export async function getRates(params: BaseParams) {
    const target = links.nft().public.conversionRate;

    // All `rates` are captured as relative to USD.
    return Request.getRequest<CurrencyResponse>({
        ...params,
        target,
        query: {
            ids: supportedCurrencies.join(','),
            vs_currencies: 'usd',
            // precision: 'full',
        },
        settings: {
            ...params.settings,
        },
    });
}

export async function callGetRates(params: BaseParams) {
    return apiFactory()
        .call(getRates, {
            ...params,
            settings: {
                ...params.settings,
            },
        })
        .then((result) => {
            if (!result?.ok) {
                const errorMessage = result.error.detail ?? 'Error getting exchange rates';
                setError({
                    error: errorMessage,
                    log: false,
                });
            }
            return result;
        });
}
